// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3fLP_","inner":"Form_inner__1Ovg6","range":"Form_range__2McgP","name":"Form_name__1s_3n","actions":"Form_actions__1rzcr"};